// src/utils/capitolatiStandard.js
// Modelli di capitolato di manutenzione — un punto di partenza professionale, riutilizzabile
// e personalizzabile, per non dover scrivere da zero ogni volta l'elenco delle operazioni di
// un contratto. Ogni voce ha la propria cadenza indipendente (mai un'unica frequenza per
// tutto il capitolato): un serraggio annuale e una verifica semestrale convivono nello stesso
// piano senza bisogno di due piani separati.
//
// Le cadenze qui sono un punto di partenza di buona pratica, non un vincolo normativo
// assoluto — restano sempre modificabili voce per voce quando si applica il modello a un
// cliente specifico, perché ogni impianto e ogni contratto può avere esigenze diverse.

export const FREQUENZE_VOCE = {
  1:  "Mensile",
  3:  "Trimestrale",
  6:  "Semestrale",
  12: "Annuale",
  24: "Biennale",
  36: "Triennale",
};

export const CAPITOLATI_STANDARD = {
  fotovoltaico: {
    nome: "Fotovoltaico",
    icona: "☀️",
    voci: [
      { testo: "Pulizia moduli fotovoltaici", frequenzaMesi: 12 },
      { testo: "Serraggio connessioni quadro stringhe (DC)", frequenzaMesi: 12 },
      { testo: "Serraggio connessioni quadro generale (AC)", frequenzaMesi: 12 },
      { testo: "Verifica tensione e corrente per stringa", frequenzaMesi: 12 },
      { testo: "Controllo parametri e allarmi inverter", frequenzaMesi: 12 },
      { testo: "Controllo funzionamento ventole/raffreddamento inverter", frequenzaMesi: 12 },
      { testo: "Verifica sezionatori e interruttori DC/AC", frequenzaMesi: 12 },
      { testo: "Termografia quadri e connessioni", frequenzaMesi: 12 },
      { testo: "Controllo strutture di sostegno e stato corrosione", frequenzaMesi: 12 },
      { testo: "Verifica messa a terra e scaricatori di sovratensione", frequenzaMesi: 12 },
      { testo: "Controllo sistema di monitoraggio e produzione attesa", frequenzaMesi: 12 },
      { testo: "Pulizia e controllo canaline/passacavi", frequenzaMesi: 12 },
      { testo: "Verifica tenuta guarnizioni quadri (IP)", frequenzaMesi: 24 },
    ],
  },
  elettrico_industriale: {
    nome: "Impianto elettrico industriale",
    icona: "⚡",
    voci: [
      { testo: "Serraggio morsetti e connessioni quadri elettrici", frequenzaMesi: 12 },
      { testo: "Prova pulsante test interruttori differenziali", frequenzaMesi: 6 },
      { testo: "Termografia quadri elettrici in esercizio", frequenzaMesi: 12 },
      { testo: "Verifica continuità impianto di terra", frequenzaMesi: 12 },
      { testo: "Controllo funzionamento interruttori magnetotermici", frequenzaMesi: 12 },
      { testo: "Pulizia interna quadri elettrici", frequenzaMesi: 12 },
      { testo: "Verifica autonomia e funzionamento illuminazione di emergenza", frequenzaMesi: 6 },
      { testo: "Controllo prese industriali CEE e relativi interblocchi", frequenzaMesi: 12 },
      { testo: "Ispezione canaline e passerelle portacavi", frequenzaMesi: 12 },
      { testo: "Controllo motori, avviatori e teleruttori", frequenzaMesi: 12 },
      { testo: "Verifica segnaletica di sicurezza e cartellonistica quadri", frequenzaMesi: 12 },
      { testo: "Controllo serraggio e stato del quadro generale (QGBT)", frequenzaMesi: 12 },
    ],
  },
  cabina_ricezione: {
    nome: "Cabina di ricezione MT",
    icona: "🔌",
    voci: [
      { testo: "Verifica funzionamento interruttore generale MT", frequenzaMesi: 12 },
      { testo: "Controllo sezionatori di manovra e di terra", frequenzaMesi: 12 },
      { testo: "Prova e taratura relè di protezione", frequenzaMesi: 12 },
      { testo: "Ispezione isolatori e sbarre MT", frequenzaMesi: 12 },
      { testo: "Controllo serraggi connessioni MT", frequenzaMesi: 12 },
      { testo: "Verifica sistema di segnalazione presenza tensione", frequenzaMesi: 12 },
      { testo: "Controllo lampade spia e blocchi meccanici/elettrici", frequenzaMesi: 12 },
      { testo: "Pulizia e controllo generale locale cabina", frequenzaMesi: 6 },
      { testo: "Verifica impianto di terra della cabina", frequenzaMesi: 24 },
      { testo: "Controllo tenuta porte tagliafuoco e ventilazioni locale", frequenzaMesi: 12 },
    ],
  },
  cabina_trasformazione: {
    nome: "Cabina di trasformazione MT/BT",
    icona: "🔋",
    voci: [
      { testo: "Analisi olio trasformatore (se in olio)", frequenzaMesi: 12 },
      { testo: "Verifica temperatura e ventilazione trasformatore", frequenzaMesi: 6 },
      { testo: "Controllo serraggi connessioni lato BT", frequenzaMesi: 12 },
      { testo: "Verifica protezioni lato BT", frequenzaMesi: 12 },
      { testo: "Controllo generale quadro BT", frequenzaMesi: 12 },
      { testo: "Verifica messa a terra della cabina", frequenzaMesi: 24 },
      { testo: "Controllo tenuta meccanica e assenza perdite (trasformatori in olio)", frequenzaMesi: 12 },
      { testo: "Pulizia trasformatore e quadri elettrici", frequenzaMesi: 12 },
      { testo: "Verifica sistema di raffreddamento/ventilazione forzata", frequenzaMesi: 6 },
      { testo: "Controllo rumorosità e vibrazioni anomale", frequenzaMesi: 12 },
    ],
  },
  videosorveglianza: {
    nome: "Videosorveglianza (TVCC)",
    icona: "📹",
    voci: [
      { testo: "Pulizia ottiche, cupole e custodie delle telecamere", frequenzaMesi: 6 },
      { testo: "Verifica messa a fuoco, inquadratura e campo di ripresa", frequenzaMesi: 6 },
      { testo: "Controllo visione notturna e funzionamento illuminatori IR", frequenzaMesi: 6 },
      { testo: "Verifica funzionamento brandeggio, zoom e preset (telecamere PTZ)", frequenzaMesi: 12 },
      { testo: "Controllo staffe, supporti, snodi e serraggio viti di fissaggio", frequenzaMesi: 12 },
      { testo: "Verifica tenuta stagna di custodie, pressacavi e guarnizioni", frequenzaMesi: 12 },
      { testo: "Controllo alimentazione telecamere (PoE / alimentatori) e tensioni", frequenzaMesi: 12 },
      { testo: "Controllo cablaggi, connettori, giunzioni e passacavi", frequenzaMesi: 12 },
      { testo: "Verifica stato NVR/DVR: LED, ventole, temperatura, allarmi di sistema", frequenzaMesi: 6 },
      { testo: "Controllo stato hard disk (S.M.A.R.T.) e spazio disponibile", frequenzaMesi: 6 },
      { testo: "Verifica dei giorni di registrazione effettivamente disponibili", frequenzaMesi: 6 },
      { testo: "Prova di registrazione, riproduzione ed esportazione filmati", frequenzaMesi: 6 },
      { testo: "Verifica sincronizzazione data/ora (NTP) di telecamere e registratore", frequenzaMesi: 6 },
      { testo: "Verifica rilevazione movimento, analisi video e notifiche", frequenzaMesi: 12 },
      { testo: "Aggiornamento firmware telecamere e registratore", frequenzaMesi: 12 },
      { testo: "Backup della configurazione di telecamere e registratore", frequenzaMesi: 12 },
      { testo: "Verifica utenti, password (nessuna di default) e permessi di accesso", frequenzaMesi: 12 },
      { testo: "Verifica accesso remoto, app e cloud (sicurezza e funzionamento)", frequenzaMesi: 12 },
      { testo: "Controllo switch di rete dedicato e collegamenti PoE", frequenzaMesi: 12 },
      { testo: "Controllo UPS/gruppo di continuità: autonomia e stato batterie", frequenzaMesi: 12 },
      { testo: "Verifica monitor e postazione di controllo", frequenzaMesi: 12 },
      { testo: "Controllo cartellonistica e informativa videosorveglianza (privacy)", frequenzaMesi: 12 },
    ],
  },
  allarme: {
    nome: "Impianto di allarme antintrusione",
    icona: "🚨",
    voci: [
      { testo: "Prova funzionale della centrale: stato, segnalazioni, guasti, memoria eventi", frequenzaMesi: 6 },
      { testo: "Verifica alimentatore, tensioni e carica della batteria tampone", frequenzaMesi: 6 },
      { testo: "Sostituzione batteria tampone della centrale", frequenzaMesi: 36 },
      { testo: "Prova di passo dei rilevatori volumetrici (PIR / doppia tecnologia)", frequenzaMesi: 6 },
      { testo: "Prova dei contatti magnetici di porte e finestre", frequenzaMesi: 6 },
      { testo: "Verifica rilevatori di rottura vetri, sismici e per tapparelle", frequenzaMesi: 12 },
      { testo: "Verifica barriere, rilevatori perimetrali e sensori esterni", frequenzaMesi: 6 },
      { testo: "Pulizia e controllo di rilevatori (ostruzioni, insetti, accecamenti)", frequenzaMesi: 6 },
      { testo: "Prova sirene interne, esterne e lampeggiante", frequenzaMesi: 6 },
      { testo: "Verifica tamper e protezione antisabotaggio di tutti i dispositivi", frequenzaMesi: 12 },
      { testo: "Controllo tastiere, lettori, chiavi elettroniche e telecomandi", frequenzaMesi: 6 },
      { testo: "Prova del comunicatore GSM/IP e invio segnalazioni a utenti/vigilanza", frequenzaMesi: 6 },
      { testo: "Verifica SIM, credito e livello di segnale GSM", frequenzaMesi: 6 },
      { testo: "Sostituzione batterie dei dispositivi wireless e verifica supervisione", frequenzaMesi: 12 },
      { testo: "Controllo cablaggi, morsettiere e linee di collegamento", frequenzaMesi: 12 },
      { testo: "Verifica mappa zone, esclusioni, programmazione e scenari", frequenzaMesi: 12 },
      { testo: "Verifica codici utente e livelli di accesso", frequenzaMesi: 12 },
      { testo: "Analisi del registro eventi e dei falsi allarmi", frequenzaMesi: 6 },
      { testo: "Aggiornamento firmware e backup della programmazione", frequenzaMesi: 12 },
      { testo: "Verifica integrazione con videosorveglianza, domotica e controllo accessi", frequenzaMesi: 12 },
      { testo: "Verifica messa a terra e protezioni da sovratensione dell'impianto", frequenzaMesi: 12 },
      { testo: "Istruzioni all'utente e verifica di conoscenza delle procedure", frequenzaMesi: 12 },
    ],
  },
  rete_dati: {
    nome: "Rete dati e cablaggio strutturato",
    icona: "🌐",
    voci: [
      { testo: "Ispezione armadio rack: ordine, pulizia, etichettatura e chiusure", frequenzaMesi: 6 },
      { testo: "Controllo temperatura, ventilazione e filtri dell'armadio", frequenzaMesi: 6 },
      { testo: "Verifica stato apparati attivi (switch, router, firewall, access point)", frequenzaMesi: 6 },
      { testo: "Controllo log e allarmi degli apparati", frequenzaMesi: 6 },
      { testo: "Backup della configurazione degli apparati", frequenzaMesi: 6 },
      { testo: "Aggiornamento firmware degli apparati", frequenzaMesi: 12 },
      { testo: "Aggiornamenti di sicurezza, account amministratore e password", frequenzaMesi: 6 },
      { testo: "Verifica firewall: regole, VPN e accessi remoti", frequenzaMesi: 12 },
      { testo: "Controllo VLAN, indirizzamento IP, DHCP e DNS", frequenzaMesi: 12 },
      { testo: "Verifica ridondanza: link aggregation, spanning tree, failover", frequenzaMesi: 12 },
      { testo: "Verifica linea internet, connessione di backup e failover", frequenzaMesi: 6 },
      { testo: "Misura delle prestazioni: banda, latenza, perdita di pacchetti", frequenzaMesi: 6 },
      { testo: "Verifica Wi-Fi: copertura, canali, potenza e stato degli access point", frequenzaMesi: 12 },
      { testo: "Controllo patch panel, permutazioni e cordoni di collegamento", frequenzaMesi: 12 },
      { testo: "Verifica a campione dei punti presa e dei cavi utente", frequenzaMesi: 12 },
      { testo: "Certificazione/test del cablaggio in rame (a campione)", frequenzaMesi: 24 },
      { testo: "Controllo dorsali in fibra: pulizia connettori e potenza ottica", frequenzaMesi: 12 },
      { testo: "Verifica UPS: autonomia, stato batterie e prova di intervento", frequenzaMesi: 6 },
      { testo: "Controllo messa a terra e schermature dell'armadio e dei cavi", frequenzaMesi: 12 },
      { testo: "Verifica di server, NAS e backup di rete, se presenti", frequenzaMesi: 6 },
      { testo: "Aggiornamento dell'inventario apparati e dello schema di rete", frequenzaMesi: 12 },
      { testo: "Verifica della documentazione e dell'etichettatura dei punti rete", frequenzaMesi: 12 },
    ],
  },
};
